/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react'
import Header from '../../../components/Header'
import PropTypes from 'prop-types'
import FieldGroup from '../../../components/FieldGroup'
import { Loader } from 'react-loaders'
import logoNetFinderPlus from '../../../../public/assets/images/logoNetFinderPlus-white.jpg'
import logoNetFinderPlus2 from '../../../../public/assets/images/rhetorik_new_logo_white.svg'
import 'loaders.css/src/animations/ball-clip-rotate-multiple.scss'
import './style.scss'
import '../../../../scss/adminLTE.scss'
import '../../../../scss/skin.scss'
import '../../../../scss/custom.scss'
import '../../../../scss/style.scss'
import { WhatsNewPanel } from './WhatsNewPanel'

class Login extends Component {
  constructor () {
    super()
    this.state = {
      showNews: false,
    }
  }

  handleDismissNews () {
    this.setState({ showNews: false })
  }

  render () {
    const { showNews } = this.state

    return (
      <div className='header-login'>
        {this.props.isLoading ? (
          <div className='loading'>
            <Loader type='ball-clip-rotate-multiple' active />
          </div>
        ) : null}
        <Header />
        <div className='body'>
          <div className='login-topbar'>
            <a href='https://rhetorik.com/' target='_blank'>
              <img src={logoNetFinderPlus2} alt='NetFinder+' />
            </a>
          </div>
          <div className='login-wrapper'>
            <section className='login-panels'>
              <div className='row'>
                <div className='col-lg-6 col-md-6 col-sm-9 col-xs-12'>

                  <div className={this.props.errorText ? 'left-panel panel-error' : 'left-panel'}>
                    <div className='login-logoNetFinder'>
                      <img src={logoNetFinderPlus} alt='NetFinder+' />
                    </div>
                    {this.props.errorText ? (
                      <p className='error-text'>
                        <i className='fa fa-exclamation-triangle' aria-hidden='true' />
                        &nbsp;
                        {this.props.errorText}
                      </p>
                    ) : null}
                    <h1>Sign in to your account</h1>
                    <form
                      onSubmit={evt => {
                        this.props.LogIn()
                        evt.preventDefault()
                      }}
                    >
                      <div className='form-group'>
                        <FieldGroup
                          type='email'
                          className='form-control'
                          label='Username'
                          name={'username'}
                          onChange={this.props.handleEvent}
                        />
                      </div>

                      <div className='form-group'>
                        <FieldGroup
                          type='password'
                          className='form-control'
                          label='Password'
                          name={'password'}
                          onChange={this.props.handleEvent}
                        />
                      </div>

                      <div className='login-container'>
                        <div className='login-check'>
                          <FieldGroup
                            type='checkbox'
                            name='remember'
                            id='login-remember'
                            label='Remember me'
                            onChange={eve => {
                              this.props.SetRememberMe(eve)
                            }}
                          />
                        </div>
                        <div className='login-forgot'>
                          <a onClick={() => this.props.router.push('/forgotPassword')}>
                            Forgot your password?
                          </a>
                        </div>
                      </div>
                      <div>
                        <div className='loginBtnDiv'>
                          <button type='submit' className='loginBtn'>
                            Sign in
                          </button>
                        </div>

                        <div className='login-credits'>
                          Rhetorik &#169; {String(new Date().getFullYear())}
                        </div>
                      </div>

                      <div className='clearfix ' />
                    </form>
                  </div>
                  {showNews && (
                    <WhatsNewPanel onDismiss={this.handleDismissNews.bind(this)} />
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    )
  }
}

Login.propTypes = {
  errorText: PropTypes.string,
  LogIn: PropTypes.func,
  handleEvent: PropTypes.func,
  SetRememberMe: PropTypes.func,
  isLoading: PropTypes.bool,
  router: PropTypes.object
}

export default Login
